import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from 'src/app/env.service';

export interface CustomDomainStatusResponse {
  hasCustomDomain: boolean;
  customDomain?: string;
  customDomainId?: string;
  status?: 'pending_dns' | 'cert_issued' | 'pending_ssl' | 'active' | 'error';
  cnameTarget: string;
  sslStatus?: string;
}

export interface BindDomainResponse {
  success: boolean;
  customDomain: string;
  customDomainId?: string;
  status: 'pending_dns' | 'cert_issued' | 'pending_ssl' | 'active' | 'error';
  cnameTarget: string;
  sslStatus?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomDomainService {
  private http = inject(HttpClient);
  private envService = inject(EnvService);

  private get apiUrl(): string {
    const base = (this.envService.apiUrl || '').replace(/\/+$/, '');
    return `${base}/tenant/custom-domain`;
  }

  getCustomDomain(): Observable<CustomDomainStatusResponse> {
    return this.http.get<CustomDomainStatusResponse>(this.apiUrl);
  }

  bindCustomDomain(domain: string): Observable<BindDomainResponse> {
    return this.http.post<BindDomainResponse>(this.apiUrl, { domain });
  }

  applyCertificate(certArn?: string): Observable<BindDomainResponse> {
    return this.http.post<BindDomainResponse>(`${this.apiUrl}/apply-certificate`, { certArn });
  }

  unbindCustomDomain(): Observable<{ success: boolean; message: string }> {
    return this.http.delete<{ success: boolean; message: string }>(this.apiUrl);
  }
}
